import StatusIcon from './StatusIcon';
import Row from './Row';
import { Box } from '@mui/material';

const StatusText = ({children, status = ""}) => {

  return (
    <Row>
      <StatusIcon status={status}/>
      <Box sx={{mx: 1}}>{children}</Box>
    </Row>
  );
}
export default StatusText;
